import React from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import EntityPropTypes from 'propTypes/entities';

import {
	cardCropTextDefault,
	imageCardSizeDefault
} from 'utils/helpers/entities';

import BaseCard from './BaseCard';

const PersonCard = ({
	className,
	cropTextParams,
	entity,
	onFocus,
	params,
	typeWidth
}) => {
	const { title, thumbnailFile, country, rubrics } = entity;

	const [firstName, surnameOrSecondName, surnameOrUndefined] = title.split(' ');
	const name = surnameOrUndefined
		? `${firstName} ${surnameOrSecondName}`
		: firstName;
	const surname = surnameOrUndefined || surnameOrSecondName;

	const url = getEntityUrl('persons', entity);

	const attributes = rubrics.map((rubric) => rubric.title);

	return (
		<BaseCard
			{...{
				attributes,
				className,
				cropTextParams,
				onFocus,
				params,
				thumbnailFile,
				typeWidth,
				url
			}}
			description={country?.title || null}
			placeholderAlign="center"
			placeholderImage="persons"
			subTitle={name}
			theme="person"
			title={surname}
			entityType="persons"
		/>
	);
};

PersonCard.propTypes = {
	className: PropTypes.string,
	cropTextParams: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	}),
	entity: EntityPropTypes.publication.isRequired,
	onFocus: PropTypes.func,
	params: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	typeWidth: PropTypes.oneOf([
		'fixedPortrait',
		'fluidPortraitSlide',
		'landingPortrait'
	])
};

PersonCard.defaultProps = {
	cropTextParams: cardCropTextDefault,
	params: imageCardSizeDefault.portrait
};

export default PersonCard;
